interface MediaQuery {
    smallOnly: MediaQueryList;
    mediumUp: MediaQueryList;
    mediumOnly: MediaQueryList;
    largeUp: MediaQueryList;
    largeOnly: MediaQueryList;
}

interface MQ {
    isSmallOnly: boolean;
    isMediumUp: boolean;
    isMediumOnly: boolean;
    isLargeUp: boolean;
    isLargeOnly: boolean;
}

export function mediaQueries(): MediaQuery {
    return {
        smallOnly: window.matchMedia('screen and (max-width: 39.9375em)'),
        mediumUp: window.matchMedia('screen and (min-width: 40em)'),
        mediumOnly: window.matchMedia('screen and (min-width: 40em) and (max-width: 63.9375em)'),
        largeUp: window.matchMedia('screen and (min-width: 64em)'),
        largeOnly: window.matchMedia('screen and (min-width: 64em) and (max-width: 74.9375em)')
    };
}

export function mq(): MQ {
    return {
        isSmallOnly: mediaQueries().smallOnly.matches,
        isMediumUp: mediaQueries().mediumUp.matches,
        isMediumOnly: mediaQueries().mediumOnly.matches,
        isLargeUp: mediaQueries().largeUp.matches,
        isLargeOnly: mediaQueries().largeOnly.matches
    };
}

export const mediaQueriesObject: Record<string, any> = {
    smallOnly: matchMedia('screen and (max-width: 39.9375em)'),
    mediumUp: matchMedia('screen and (min-width: 40em)'),
    mediumOnly: matchMedia('screen and (min-width: 40em) and (max-width: 63.9375em)'),
    largeUp: matchMedia('screen and (min-width: 64em)'),
    largeOnly: matchMedia('screen and (min-width: 64em) and (max-width: 74.9375em)')
};

export const mqObject: Record<string, any> = {
    isSmallOnly: mediaQueries().smallOnly.matches,
    isMediumUp: mediaQueries().mediumUp.matches,
    isMediumOnly: mediaQueries().mediumOnly.matches,
    isLargeUp: mediaQueries().largeUp.matches,
    isLargeOnly: mediaQueries().largeOnly.matches
};

export function watchSmallScreen(callback: (x: MediaQueryListEvent) => void): void {
    mediaQueriesObject.smallOnly.addEventListener('change', callback);
}

interface mqI {
    isSmallOnly: boolean,
    isMediumUp: boolean,
    isMediumOnly: boolean,
    isLargeUp: boolean,
    isLargeOnly: boolean
}
